<template>
  <div class="list-item with-icon">
    <v-list-item-avatar tile>
      <v-img height="30px" contain src="@/assets/svg/booking_list_icon.svg" />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right flex-nowrap align-start">
        <div class="description mr-2">
          <div :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold">{{ job.title }}</span>
            <span class="booking-id" :class="{ 'd-block': isMobile }">
              <span class="mx-1" v-if="!isMobile"> | </span>
              <span class="booking-list-item__mono">R-{{ job.id }}</span>
            </span>
            <Permissioned
              section="bookings.view"
              class="deadline-date d-inline"
            >
              <span permission="deadline-date">
                <span class="mx-1" v-if="!isMobile">|</span>
                <v-icon>mdi-timer-sand-empty</v-icon>
                {{ job.deadlineDate | baseDate }}
              </span>
            </Permissioned>
          </div>
          <div class="status-wrapper">
            <div
              v-for="(status, key, index) in applicationStatuses"
              :key="index"
              class="application-status-item"
            >
              <span class="mr-1"> {{ status }} </span>
              <span class="status mr-2"> {{ key | capitalize }} </span>
            </div>
          </div>
        </div>
        <Chip :color="getColorByStatus(job.status)" class="chip--status">
          {{ job.status | upperCase }}
        </Chip>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { get } from "lodash";
import { getColorByStatus } from "@/utils/bookings";
import Chip from "@/components/common/Chip";
import Permissioned from "@/components/common/Permissioned";

export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  components: {
    Chip,
    Permissioned
  },
  computed: {
    applicationStatuses() {
      return get(this.job, "meta.applications");
    }
  },
  methods: {
    getColorByStatus
  }
};
</script>

<style lang="scss" scoped>
.booking-list-item__mono,
.chip--status {
  flex-shrink: 0;
}
.booking-id,
.deadline-date {
  white-space: nowrap;
}
</style>
